angular.module 'app'
.controller 'TemplateMsgCtrl', ($scope, $http, $stateParams, $state, config, Storage, SweetAlert ,$sce,  dialogs, growl) ->
  return $state.go 'app.wechat' if Storage.get('user_permission').issue.template.templateMsg.is_use == false

  $scope.ui =
    user: Storage.get('login_user')
    resourcesUrl: config.resources.baseUrl

    msgObjType: '0'
    isShowTimeSelect: false

    tag_id: 'all'
    fansGroups: []
    fansArr: []
    quota:
      daily_limit: 0
      used: 0
      remain: 0

    reset_quota: {}

    activeObj: {}

    jumpUrl: ''

    date: moment().format('YYYY-MM-DD HH:mm:ss')
    opts:
      autoApply: true
      parentEl: 'div#view-fans-message'
      minDate: moment().format('YYYY-MM-DD HH:mm:ss')
      opens: 'center'
      drops: 'down'
      timePicker: true
      timePicker24Hour: true
      timePickerSeconds: true
      singleDatePicker: true
      locale:
        format: 'YYYY-MM-DD HH:mm:ss'
        applyLabel: '應用'
        cancelLabel: '取消'
        daysOfWeek: ['日', '一', '二', '三', '四', '五','六']
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']

  $http.get "#{config.api.baseUrl}/wechat?access_token=" + Storage.get('access_token'),
    params:
      user_group_id: $scope.ui.user.group_id
      original_id: $stateParams.original_id
  .then (res) ->
    if res.data.count > 0 then $scope.ui.wechat = res.data.data[0]
  .catch (error) ->
    if error.data.error.indexOf('errtext') >= 0
      err = JSON.parse error.data.error
      growl.error err.errtext
    else
      growl.error('網絡連接失敗，請稍後重試')

  fetchNewQuota = ->
    $http.post "#{config.api.baseUrl}/wechat/#{$stateParams.original_id}/get-openapi-quota?access_token=" + Storage.get('access_token'),
      cgi_path: "/cgi-bin/openapi/quota/clear"
    .then (resQuota) ->
      $scope.ui.reset_quota =
        daily_limit: resQuota.data.quota.daily_limit
        remain: resQuota.data.quota.remain
        used: resQuota.data.quota.used

  fetchNewQuota()

  # 處理模板數據
  getTemplate = ->
    if $scope.ui.activeObj.content != undefined
      html_str = $scope.ui.activeObj.content.replace(new RegExp('\n','g'),'<br>').split('<br>')
      keys = []
      _.each html_str, (val) ->
        _name = _key = _val = ''
        _color = '#173177'
        _name = val.split('{{')[0]
        _key = val.split('{{')[1].split('.DATA}}')[0] if val.split('{{')[1] != undefined
        keys.push {name: _name, key: _key, val: _val, color: _color}
      $scope.ui.activeObj.example_html = $sce.trustAsHtml $scope.ui.activeObj.example.replace(new RegExp('\n','g'),'<br>')
      $scope.ui.activeObj.content_val = keys

  # 套用
  $scope.setValue = ->
    $scope.ui.jumpUrl = 'http://mp.weixin.qq.com/s/rGKwEeDV2Ipe6DIOD7-WUA' if $scope.ui.activeObj._id == '58b630664ad46a00187d2f5e'
    _strs = $scope.ui.activeObj.example.replace(new RegExp('\n','g'),'<br>').split('<br>')

    _.each $scope.ui.activeObj.content_val, (data, i) ->
      if data.name == ''
        data.val = _strs[i]
      else
        data.val = _strs[i].substring(_strs[i].indexOf(data.name) + data.name.length)

  # 编制
  $scope.setExample = ->
    $scope.ui.activeObj.content_edit = angular.copy $scope.ui.activeObj.content_val

    _strs = $scope.ui.activeObj.example.replace(new RegExp('\n','g'),'<br>').split('<br>')

    _.each $scope.ui.activeObj.content_edit, (data, i) ->
      data.color = '#173177'
      if data.name == ''
        data.val = _strs[i]
      else
        data.val = _strs[i].substring(_strs[i].indexOf(data.name) + data.name.length)

  # 保存示例
  $scope.saveExample = ->
    _str = angular.copy $scope.ui.activeObj.content
    _.each $scope.ui.activeObj.content_edit, (data, i) ->
      _str = _str.replace('{{' + data.key + '.DATA}}', data.val)

    $http.put "#{config.api.baseUrl}/#{$stateParams.original_id}/template/#{$scope.ui.activeObj._id}?access_token=" + Storage.get('access_token'),
      example: _str
    .then (res) ->
      $scope.ui.activeObj.example = _str
      getTemplate()
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  # 查詢粉絲分組
  findGroups = ->
    $http.get "#{config.api.baseUrl}/#{$stateParams.original_id}/follower/tag?access_token=" + Storage.get('access_token'),{
      params:
        limit: 99
    }
    .then (res) ->
      $scope.ui.fansGroups = res.data.data
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')
  # 打开选择粉丝列表
  findFans = ->
    dlg = dialogs.create('apps/material/graphic/select/select', 'SelectPeopleCtrl', {text: '選擇人數必須小於等於 10000 人，大於等於 1 人', openid: $scope.ui.fansArr}, {size: 'md'})
    dlg.result.then ((option) ->
      return if option == 'Cancel'
      $scope.ui.fansArr = option
    ), ->

  # 獲取模板api quota
  do fetchQuota = ->
    $http.get "#{config.api.baseUrl}/#{$stateParams.original_id}/template/quota?access_token=" + Storage.get('access_token'),{}
    .then (res) ->
      if res.data.errcode == 0
        $scope.ui.quota = res.data.quota
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  $scope.open = ->
    dialogs.create('apps/template/template-msg/modal/modal', 'TemplateMsgModalCtrl', {}, {size: 'lg'})
    .result.then ((option) ->
      return if option == 'Cancel'
      $scope.ui.jumpUrl = ''
      $scope.ui.activeObj = option
      getTemplate()
    ), ->

  $scope.testSend = ->
    verificationTemplate((status, data) ->
      _.each data, (val) ->
        delete val.remarkVal
      return growl.error data if status == false
      dlg = dialogs.create('apps/material/graphic/select/select', 'SelectPeopleCtrl', {text: '選擇人數必須小於等於 10000 人，大於等於 1 人'}, {size: 'md'})
      dlg.result.then ((option) ->
        return if option == 'Cancel'
        $http.post "#{config.api.baseUrl}/#{$stateParams.original_id}/testsend?access_token=" + Storage.get('access_token'),
          template_id: $scope.ui.activeObj._id
          openids: option
          data: data
          url: $scope.ui.jumpUrl
        .then (res) ->
          growl.success('測試發送成功')
        .catch (error) ->
          if error.data.error.indexOf('errtext') >= 0
            err = JSON.parse error.data.error
            growl.error err.errtext
          else
            growl.error('網絡連接失敗，請稍後重試')
      ), ->
    )

  # 模板驗證
  verificationTemplate = (callback) ->
    _status = false
    _.each $scope.ui.activeObj, (data) ->
      _status = true
    return callback _status, '請選擇模板' if _status == false

    _str = '{'
    _length = $scope.ui.activeObj.content_val.length - 1
    _.each $scope.ui.activeObj.content_val, (key, _index) ->
      key.val = "" if !key.val
      key.remarkVal = true if !key.val && key.key == 'remark'
      _val = key.val.replace(/\n/g,'').replace('\r','').replace(/\"/g, '\'')
      _val = "" if key.key == 'first'
      _val = "" if key.key == 'remark'
      if _index != _length && key.key != ''
        _str += '"' + key.key + '": {"value": "' + _val + '", "color": "' + key.color + '"},'
      else if _index == _length && key.key != ''
        _str += '"' + key.key + '": {"value": "' + _val + '", "color": "' + key.color + '"}'
      # _str += key.key + ': {value: "' + _val + '", color: "' + key.color + '", remarkVal: ' + key.remarkVal + '},' if key.key != ''

    _str += '}'
    str = JSON.parse(_str)
    # str = eval("(" + _str + ")")
    _status = true
    # _.each str, (e) ->
    #   _status = false if e.value == '' && !e.remarkVal

    return callback _status, '請填寫模板內容' if _status == false
    return callback _status, str if _status == true

  # 條件數據處理
  conditionData = (callback) ->
    _obj = {}
    _obj.template_id = $scope.ui.activeObj._id
    _obj.send_type = 'immediately'
    _obj.send_type = 'timing' if $scope.ui.isShowTimeSelect == true
    _obj.send_at = ''
    _obj.send_at = $scope.ui.date if $scope.ui.isShowTimeSelect == true
    _obj.group_id = 'all' if $scope.ui.msgObjType == '0' && $scope.ui.tag_id == 'all'
    _obj.tag_id = $scope.ui.tag_id if $scope.ui.msgObjType == '0' && $scope.ui.tag_id != 'all'
    _obj.openids = $scope.ui.fansArr if $scope.ui.msgObjType == '1'
    _obj.created_by = $scope.ui.user.id
    callback _obj

  # $scope.save = ->
  #   verificationTemplate((status, data) ->
  #     return growl.error data if status == false
  #     $http.put "#{config.api.baseUrl}/#{$stateParams.original_id}/template/#{$scope.ui.activeObj._id}?access_token=" + Storage.get('access_token'),
  #       data: data
  #     .then (res) ->
  #       growl.success('保存成功')
  #     .catch (error) ->
  #       if error.data.error.indexOf('errtext') >= 0
  #         err = JSON.parse error.data.error
  #         growl.error err.errtext
  #       else
  #         growl.error('網絡連接失敗，請稍後重試')
  #   )

  # $scope.send = ->
  #   verificationTemplate((status, data) ->
  #     return growl.error data if status == false
  #     conditionData((obj) ->
  #       return growl.error '自定義粉絲人數必須小於等於 10000 人，大於等於 1 人' if $scope.ui.msgObjType == '1' && (obj.openids.length < 2 || obj.openids.length > 10000)
  #       $http.put "#{config.api.baseUrl}/#{$stateParams.original_id}/template/#{$scope.ui.activeObj._id}?access_token=" + Storage.get('access_token'),
  #         data: data
  #       .then (res) ->
  #         $http.post "#{config.api.baseUrl}/#{$stateParams.original_id}/testsend?access_token=" + Storage.get('access_token'), obj
  #         .then (res) ->
  #           if res.status == 200
  #             growl.success('測試發送成功')
  #           else
  #             growl.error('網絡連接失敗，請稍後重試')
  #         .catch (error) ->
  #           if error.data.error.indexOf('errtext') >= 0
  #             err = JSON.parse error.data.error
  #             growl.error err.errtext
  #           else
  #             growl.error('網絡連接失敗，請稍後重試')
  #       .catch (error) ->
  #         if error.data.error.indexOf('errtext') >= 0
  #           err = JSON.parse error.data.error
  #           growl.error err.errtext
  #         else
  #           growl.error('網絡連接失敗，請稍後重試')
  #     )
  #   )

  # 发布提交
  $scope.submit = ->
    if $scope.ui.date is null or !moment($scope.ui.date).isValid()
      $scope.ui.date = moment().format('YYYY-MM-DD HH:mm:ss')
      return growl.error('請輸入正確的時間')

    verificationTemplate((status, data) ->
      _.each data, (val) ->
        delete val.remarkVal
      return growl.error data if status == false
      conditionData((obj) ->
        return growl.error '自定義粉絲人數必須小於等於 10000 人，大於等於 1 人' if $scope.ui.msgObjType == '1' && (obj.openids.length < 1 || obj.openids.length > 10000)
        obj.data = data
        obj.url = $scope.ui.jumpUrl
        $http.post "#{config.api.baseUrl}/#{$stateParams.original_id}/task?access_token=" + Storage.get('access_token'), obj
        .then (res) ->
          if res.status == 200
            growl.success('發佈申請提交成功')
          else
            growl.error('網絡連接失敗，請稍後重試')
        .catch (error) ->
          if error.data.error.indexOf('errtext') >= 0
            err = JSON.parse error.data.error
            growl.error err.errtext
          else
            growl.error('網絡連接失敗，請稍後重試')
      )
    )

  $scope.$watch 'ui.msgObjType', (newValue) ->
    if newValue == '0'
      findGroups()

  $scope.chooseFans = ->
    findFans()

  $scope.setColor = (_index, _color) ->
    $scope.ui.activeObj.content_val[_index].color = _color

  $scope.reset = ->
    SweetAlert.swal {
      title: "確定重置模板消息發佈次數？"
      text: "本月已重置#{$scope.ui.reset_quota.used}/#{$scope.ui.reset_quota.daily_limit}次。"
      type: "warning"
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      cancelButtonText: '取消'
      confirmButtonText: '確定'
    }, (isConfirm) ->
      if isConfirm
        $http.post "#{config.api.baseUrl}/wechat/#{$scope.ui.wechat._id}/clear-openapi-quota?access_token=" + Storage.get('access_token'), {}
        .then (res) ->
          fetchNewQuota()
          growl.success "重置成功！"
        .catch (error) ->
          if error.data.error.indexOf('errtext') >= 0
            err = JSON.parse error.data.error
            growl.error err.errtext
          else
            growl.error('網絡連接失敗，請稍後重試')